import { useState } from "react";

import { MdContentCopy } from "react-icons/md";
import { sendCreateEvent } from "./Axios";

// This is a placeholder function; you'll need to define it properly
const generateRandomWord = () => {
  return Math.random().toString(36).substring(2, 8); // Example: a random string
};

interface CreateEventProps {
  onClose: () => void;
}

const CreateEvent = ({ onClose }: CreateEventProps) => {
  const [name, setName] = useState("");
  const [username, setUsername] = useState("");
  // New state to manage the modal's open/close status

  // Assuming 'code' is meant to be a static value or a state variable
  const [code, setCode] = useState("example_code");

  const handleNameChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setName(e.target.value);
  };

  // New function to handle copying text to the clipboard
  const handleCopy = (text: string) => {
    navigator.clipboard.writeText(text);
  };

  const createAnEvent = () => {
    sendCreateEvent(name, username, code); // Pass the correct state variables
    onClose(); // Call onClose as a function
  };

  return (
    <div onClick={(e) => e.stopPropagation()} className="modal-content">
      <div onClick={onClose}>close</div>
      <div className="relative z-100 w-full">
        <textarea
          className="w-full relative z-10"
          value={name}
          onChange={handleNameChange}
          placeholder="Enter event name"
        />
      </div>
      {/* Updated props to use useState */}

      <h1 className="text-3xl mb-4 ">Here's your Sharing information</h1>
      <p className="font-light mb-2">
        Send this to people that you want to discuss with. Make sure that you
        save it so that you can use it later, too.
      </p>
      <span className="flex items-center bg-blue-100 p-2 rounded font-light text-gray-900 text-[13px]">
        <p>{window.location.href}</p>
        <div className="w-full justify-items-end">
          {" "}
          {/* Updated onClick to use the new function */}
          <MdContentCopy
            fontSize={"20px"}
            cursor={"pointer"}
            onClick={() => handleCopy(window.location.href)}
          />
        </div>
      </span>
      <p className="font-light my-3">or create a personal discussion</p>
      <span className="flex items-center  bg-blue-100 p-2 rounded font-light text-gray-900 text-[13px]">
        <p>{window.location.href + "?id=" + generateRandomWord()}</p>
        <div className="w-full justify-items-end">
          {" "}
          {/* Updated onClick to use the new function */}
          <MdContentCopy
            fontSize={"20px"}
            cursor={"pointer"}
            onClick={() =>
              handleCopy(window.location.href + "?id=" + generateRandomWord())
            }
          />
        </div>
      </span>

      <button onClick={createAnEvent}>Submit</button>
    </div>
  );
};

export default CreateEvent;
